import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Botao } from '../../componentes/ui';
import { atividadesDoCard, type AtividadeDoCrm } from '../../servicos/crm';
import { ErroDaApi } from '../ErroDaApi';
import { FormularioDeAtividade, LinhaDeAtividade } from './ComponentesDeAtividade';

/**
 * As atividades dentro do card: as abertas à vista, as concluídas recolhidas.
 * O que está feito vale como histórico, mas não deve disputar espaço com o que
 * ainda falta.
 */
export function AtividadesDoCard(props: { readonly cardId: string }): JSX.Element {
  const [formulario, setFormulario] = useState<{ atividade?: AtividadeDoCrm } | null>(null);
  const [verConcluidas, setVerConcluidas] = useState(false);

  const consulta = useQuery({
    queryKey: ['crm', 'atividades', 'card', props.cardId],
    queryFn: () => atividadesDoCard(props.cardId),
  });

  const todas = consulta.data ?? [];
  const abertas = todas.filter((a) => a.concluidaEm === null);
  const concluidas = todas.filter((a) => a.concluidaEm !== null);

  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-center justify-between gap-3">
        <h3 className="text-xs font-semibold uppercase tracking-wide text-conteudo-sutil">
          Atividades ({abertas.length})
        </h3>
        <Botao variante="secundario" tamanho="pequeno" onClick={() => setFormulario({})}>
          + Nova atividade
        </Botao>
      </div>

      {consulta.isError && (
        <ErroDaApi titulo="Não foi possível carregar as atividades" erro={consulta.error} />
      )}

      {abertas.length === 0 && consulta.isSuccess && (
        <p className="text-sm text-conteudo-secundario">
          Nada em aberto. Crie a próxima tarefa para não perder o fio com esta empresa.
        </p>
      )}
      {abertas.length > 0 && (
        <ul className="flex flex-col gap-2">
          {abertas.map((a) => (
            <LinhaDeAtividade
              key={a.id}
              atividade={a}
              aoEditar={() => setFormulario({ atividade: a })}
            />
          ))}
        </ul>
      )}

      {concluidas.length > 0 && (
        <div className="flex flex-col gap-2">
          <button
            type="button"
            aria-expanded={verConcluidas}
            onClick={() => setVerConcluidas((v) => !v)}
            className="self-start text-xs text-conteudo-secundario underline-offset-2 hover:underline"
          >
            {verConcluidas ? 'Esconder' : 'Ver'} concluídas ({concluidas.length})
          </button>
          {verConcluidas && (
            <ul className="flex flex-col gap-2">
              {concluidas.map((a) => (
                <LinhaDeAtividade
                  key={a.id}
                  atividade={a}
                  aoEditar={() => setFormulario({ atividade: a })}
                />
              ))}
            </ul>
          )}
        </div>
      )}

      {formulario !== null && (
        <FormularioDeAtividade
          cardId={props.cardId}
          {...(formulario.atividade === undefined ? {} : { atividade: formulario.atividade })}
          aoFechar={() => setFormulario(null)}
        />
      )}
    </section>
  );
}
